function listFunction() {
  document.getElementById("DropdownDiv").classList.toggle("show");
}

// Close the dropdown if the user clicks outside of it
window.onclick = function(event) {
  if (!event.target.matches('.dropbtn')) {
    var dropdowns = document.getElementsByClassName("dropdown-content");
    var i;
    for (i = 0; i < dropdowns.length; i++) {
      var openDropdown = dropdowns[i];
      if (openDropdown.classList.contains('show')) {
        openDropdown.classList.remove('show');
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const blogDetail = window.location.toString().match(/tagged/);

  if (blogDetail) {
    const pageUrl = window.location.pathname;
    const linkUrl = pageUrl.split('/')[4];

    // Change Button Text as per the active Filter.
    const buttonText = document.querySelector('.dropbtn');
    buttonText.innerHTML = linkUrl.charAt(0).toUpperCase() + linkUrl.slice(1);

    // Window scroll top of the news listing section.
    const element = document.getElementById("blog-posts");
    let pos = element.offsetTop - 200;
    window.scrollTo({top: pos, behavior: 'smooth'});
  }
});
